<template>
  <div class="ml_auction_detail" ref="auctionDetailRef">
    <div class="ml_auction_card">
      <div class="ml_auction_storename">
        {{ detailInfo.storeName || '-' }}
      </div>

      <div class="ml_auction_position">
        <div class="ml_auction_car_img_content">
          <img v-if="detailInfo.firstImage" :src="detailInfo.firstImage + '?x-oss-process=image/resize,w_640,h_480/quality,q_90'" mode="aspectFill" class="ml_auction_car_img" />
        </div>

        <div class="ml_auction_position_right">
          <div class="ml_auction_car_name">
            {{ detailInfo.vehicleName || '-' }}
          </div>
          <div class="ml_auction_car_info_list">
            <div class="ml_car_card_base_item">
              <span>{{ detailInfo.plate || '-' }}</span>
            </div>
            <span style="color: #E9E9E9;">|</span>
            <div class="ml_car_card_base_item">
              {{ detailInfo.registrationDate || '-' }}
            </div>
            <span style="color: #E9E9E9;">|</span>
            <div class="ml_car_card_base_item">
              <div v-if="detailInfo.drivenDistance">
                {{ detailInfo.drivenDistance }}公里
              </div>
              <div v-else>
                -
              </div>
            </div>
          </div>
          <div class="ml_auction_car_info_list">
            <div class="ml_car_card_base_item">
              VIN：<span selectable user-select>{{ detailInfo.vin || '-' }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="ml_auction_card_price">
        <div class="ml_auction_card_price_title">
          保留价
        </div>
        <div class="ml_auction_card_price_num">
          <span v-if="detailInfo.reservePriceText">{{ detailInfo.reservePriceText || '-'}}</span>
          <span v-else style="color: #c0c0c0;">——</span>
        </div>
      </div>

      <!-- <div class="ml_auction_card_price" style="margin-top: 10px;">
        <div class="ml_auction_card_price_title">
          拍卖成交价
        </div>
        <div class="ml_auction_card_price_num">
          <span v-if="detailInfo.auctionCurPriceText">{{ detailInfo.auctionCurPriceText || '-'}}</span>
          <span v-else style="color: #c0c0c0;">—</span>
        </div>
      </div> -->

      <div class="ml_auction_card_price" style="margin-top: 12px;border-top: 0.5px solid rgba(233,233,233,1);padding-top: 16px;">
        <div class="ml_auction_card_price_title">
          车源方应收款
        </div>
        <div class="ml_auction_card_price_num">
          <div v-if="detailInfo.receivableAmountText" class="ml_price_value_font">{{ detailInfo.receivableAmountText ||'-' }}</div>
          <div v-else style="color: #c0c0c0;">—</div>
          <!-- <div v-if="detailInfo.discountAmountText" style="color: #FF0000;margin-top: 2px;">(已优惠{{detailInfo.discountAmountText}})</div> -->
        </div>
      </div>
    </div>

    <div class="ml_auction_card ml_auction_list">
      <div class="ml_flex ml_flex_center">
        <div class="ml_auction_title">
          发拍时间
        </div>
        <div class="ml_flex_item">
          {{ detailInfo.sendTime || '-' }}
        </div>
      </div>
      <div class="ml_flex ml_flex_center">
        <div class="ml_auction_title">
          竞拍结束时间
        </div>
        <div class="ml_flex_item">
          {{ detailInfo.endTime || '-' }}
        </div>
      </div>
      <div class="ml_flex ml_flex_center">
        <div class="ml_auction_title">
          竞拍处理时间
        </div>
        <div class="ml_flex_item">
          {{ detailInfo.auctionDealTime || '-' }}
        </div>
      </div>
    </div>

    <div v-if="detailInfo.detectionReportUrl" class="ml_detection_report ml_flex ml_flex_center" @click="onDetectionReport">
      <img src="../../assets/66.png" class="ml_detection_report_icon" alt="">
      <div class="ml_detection_report_text">检测报告</div>
      <div class="ml_flex_item"></div>
      <div class="ml_detection_report_tip">点击查看车辆完整检测报告</div>
      <img src="../../assets/arrow_right.svg" class="ml_detection_report_img" alt="">
    </div>

    <div class="ml_auction_detail_tab">
      <div class="ml_auction_detail_tab_item">
        <div class="ml_auction_detail_tab_item_text ml_auction_detail_tab_item_active">
          发拍记录({{ detailInfo.auctionCount || shootingRecordCount }})
        </div>
      </div>
    </div>

    <!-- 发拍记录 -->
    <div class="ml_auction_record">
      <div class="ml_auction_record_list">
        <div class="ml_auction_record_item" v-for="(item, index) in shootingRecordList" :key="index">
          <div style="display: flex;justify-content: space-between;">
            <div class="ml_flex_item ml_auction_record_title">
              {{ item.sendTime || '-' }}
            </div>
            <!-- 拍卖状态(1:待入场,2：拍卖结束(流拍),3:发拍失败,4:交易成功,5结标中,6:已入场,7:中标,8:撤回发拍) -->
            <template v-if="item.auctionStatus == 3">
              <div class="ml_auction_status_end_record">
                {{ item.auctionStatusName || '-' }}
              </div>
            </template>
            <template v-else-if="item.auctionStatus == 8">
              <div class="ml_auction_status_chehui_record">
                {{ item.auctionStatusName || '-' }}
              </div>
            </template>
            <template v-else>
              <div class="ml_auction_status_record">
                {{ item.auctionStatusName || '-' }}
              </div>
            </template>
          </div>
          <van-row>
            <van-col span="12">发拍人：{{ item.sendUserName || '-' }}</van-col>
            <van-col span="12">保留价：
              <template v-if="item.reservePrice != null">
                <span class="ml_price_value_font">{{ item.reservePrice }}</span>元
              </template>
              <template v-else>-</template>
            </van-col>
          </van-row>

          <template v-if="item.rejectRemark">
            <div style="margin-top: 10px;">
              <van-row :span="24">驳回备注：{{ item.rejectRemark || '-' }}</van-row>
            </div>
          </template>

        </div>
      </div>
    </div>

    <div v-if="shootingRecordList == 0">
      <componentNoData></componentNoData>
    </div>
  </div>
</template>

<script>
import componentNoData from "@/components/componentNoData.vue"
import {
  getAuctionDetail,
  getAuctionRecords,
} from '@/utils/auction.js'

export default {
  components: {
    componentNoData,
  },
  data() {
    return {
      detailInfo: {},

      // 发拍记录
      shootingRecordList: [],
      // 发拍总数
      shootingRecordCount: 0,

      // 竞拍ID
      id: "",

    };
  },
  mounted() {
    const that = this;
    that.id = that.$route.query.id;
    that.sid = that.$route.query.sid;

    that.getDetail();
    window.scrollTo(0, 0);

  },
  methods: {
    getDetail() {
      // 获取详情
      const that = this;
      getAuctionDetail({
        id: that.id,
      }).then(res => {
        that.detailInfo = res.data;

        document.title = res.data.auctionStatusName

        // 发拍记录
        that.getAuctionRecord();

      })
    },
    getAuctionRecord() {
      // 发拍记录
      const that = this;
      getAuctionRecords({
        id: that.detailInfo.vehicleId,
      }).then(res => {
        that.shootingRecordList = res.data;
        that.shootingRecordCount = res.data.length;
      })
    },
    onDetectionReport() {
      // 跳转检测报告
      const that = this;
      if (that.detailInfo.detectionReportUrl) {
        location.href = that.detailInfo.detectionReportUrl
      }
    },
  }
}
</script>

<style lang="scss">
.ml_auction_detail {
  overflow: hidden;
  background: #f5f7f9;
  font-size: 14px;
  min-height: 100vh;

  .ml_auction_detail_top {
    height: 25px;
    background-color: #327fff;
  }

  .ml_auction_card {
    z-index: 9;
    background: #ffffff;
    padding: 10px;
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }

    .ml_auction_storename {
      color: #292d33;
      font-weight: bold;
      padding: 5px 0 10px;
      font-size: 16px;
    }
  }

  .ml_auction_car_img_content {
    width: 100px;
    height: 75px;
    border-radius: 10px;
    margin-right: 10px;
    overflow: hidden;
    position: relative;

    .ml_auction_car_img {
      width: 100%;
      height: 100%;
      display: block;
      border-radius: 10px;
    }
  }

  .ml_auction_position_right {
    width: calc(100% - 110px);
  }

  .ml_auction_car_name {
    height: 36px;
    font-size: 14px;
    color: #332d29;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /*行数*/
    -webkit-box-orient: vertical;
  }

  .ml_auction_car_info_list {
    font-size: 12px;
    color: #979797;
    padding-top: 4px;
    display: flex;

    .ml_car_card_base_item {
      padding: 0 8px;
      position: relative;
      display: inline-block;
      vertical-align: middle;
      line-height: 15px;
    }

    .ml_car_card_base_item {
      &:first-child {
        padding-left: 0;
      }
    }
  }

  .ml_auction_position {
    position: relative;
    padding-top: 5px;
    display: flex;

    .ml_auction_number {
      position: absolute;
      bottom: 0;
      right: -10px;
      color: #ffffff;
      background: #327fff;
      font-size: 12px;
      border-radius: 14px 0px 0px 14px;
      padding: 5px 15px;
    }
  }

  .ml_auction_card_price {
    margin-top: 15px;
    display: flex;
    justify-content: space-between;

    .ml_auction_card_price_title {
      font-size: 14px;
      color: #292d33;
    }

    .ml_auction_card_price_num {
      font-size: 14px;
      color: #000000;
      text-align: right;
      .ml_price_value_font {
        font-size: 18px;
        color: #292d33;
        font-weight: 600;
        line-height: 25px;
      }
    }
  }

  .ml_auction_title {
    width: 100px;
  }

  .ml_auction_list {
    color: #292d33;

    .ml_flex {
      display: flex;
      align-items: center;
      font-size: 14px;
      padding: 5px 0;
    }
  }

  .ml_detection_report {
    background: #ffffff;
    border-top: 1px solid #c5dbff;
    border-bottom: 1px solid #c5dbff;
    padding: 12px 15px;

    .ml_detection_report_icon {
      width: 24px;
      height: 24px;
      margin-right: 5px;
    }

    .ml_detection_report_text {
      font-size: 15px;
      color: #2167dc;
      font-weight: bold;
    }

    .ml_detection_report_tip {
      font-size: 11px;
      color: #666666;
      margin-right: 5px;
    }

    .ml_detection_report_img {
      display: block;
      width: 12px;
      height: 12px;
      margin-top: 4px;
    }
  }

  .ml_auction_detail_tab {
    background-color: #ffffff;
    padding: 0 15px;
    margin-bottom: 10px;
    position: sticky;
    top: 0;
    z-index: 1;
    margin-top: 10px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;

    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 1px;
      background-color: rgba($color: #eee, $alpha: 0.3);
    }

    .ml_auction_detail_tab_item {
      display: inline-block;
      padding-right: 20px;
    }

    .ml_auction_detail_tab_item_text {
      padding: 15px 0;
    }

    .ml_auction_detail_tab_item_active {
      border-bottom: 2px solid #327fff;
      // position: relative;
      color: #327fff;

      // &::after {
      //   content: "";
      //   position: absolute;
      //   width: 100%;
      //   height: 2px;
      //   background-color: #327FFF;
      //   bottom: 0;
      //   left: 50%;
      //   transform: translateX(-50%);
      // }
    }
  }

  .ml_auction_record {
    .ml_auction_record_list {
      .ml_auction_record_item {
        margin: 10px 0;
        background-color: #ffffff;
        padding: 15px;

        .ml_auction_record_title {
          line-height: 20px;
          color: #292d33;
          margin-bottom: 10px;
        }

        .ml_auction_status_record {
          color: #327fff;
          line-height: 20px;
          margin-bottom: 10px;
        }

        .ml_auction_status_end_record {
          color: #ff0000;
        }

        .ml_auction_status_chehui_record {
          color: #c0c0c0;
        }
      }
    }
  }
}
</style>